 var body = document.body;
 var sc = (function(){
	var scrollElement = 'scrollingElement' in document ? document.scrollingElement : document.documentElement;
	var scrollPoint,prePoint,flag;
	return function(){
		scrollPoint = scrollElement.scrollTop;
		flag = prePoint > scrollPoint ? true : false;
		prePoint = scrollPoint;
		return flag;
	}
})();

window.addEventListener("scroll",function(){
	if(sc()){
		body.classList.remove("scrl_down");
	}else{
		body.classList.add("scrl_down");
	}
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

$(function(){

var body=$('body');
var scrTop = 1;

$(window).on('scroll',function(){
	scrTop = $(window).scrollTop();
	scrlClass();
});

function scrlClass(){
	if(scrTop===0){
		if(!body.hasClass("scrl_top")) {
			body.addClass("scrl_top");
		}
		body.removeClass("scrl");
	}else if(scrTop>0){
		body.removeClass("scrl_top");
		if(!body.hasClass("scrl")) {
			body.addClass("scrl");
		}
	}else{
		if(body.hasClass("scrl")) {
			body.removeClass("scrl");
		}
	}
}

$('#searchBtn').on('click', function(){
	$('#Search_inline').toggleClass('active');
});

$('#drawerBtn').on('click',function(){
  body.toggleClass('navopen');
});

function masonryFunc(){
	$('#top_img').masonry({
	  // options
	  itemSelector: '.col',
	});
}

function modalFunc(){
	var modal = $(".modal").iziModal({
		width: '100%',
		navigateCaption: false,
		fullscreen: true,
		overlayColor: 'rgba(255,255,255,1)',
		transitionIn: 'fadeInUp',
		transitionOut: 'fadeOutDown',
		closeButton: false,
		onOpened: function(modal){
		},
		onClosed: function(){
		},
	});
	var data = (function () {/*
	<div class='modalclose' data-izimodal-close=''></div>
	*/}).toString().match(/(?:\/\*(?:[\s\S]*?)\*\/)/).pop().replace(/^\/\*/, "").replace(/\*\/$/, "");
	if( $('.modal').find('.modalclose').length == 0 ){
		$(".modal .info .num").append($(data));
	}
}


if( document.getElementById('top') ){
	var $grid = $('#top_img').masonry({
		itemSelector: '.col',
		columnWidth: '.colbase',
		percentPosition: true,
	});
	$grid.imagesLoaded().progress( function() {
		$grid.masonry('layout');
	});
}

if( document.getElementById('gallery') ){
	var $grid = $('.product_list').masonry({
		itemSelector: '.col',
		columnWidth: '.colbase',
		percentPosition: true
	});
	$grid.imagesLoaded().progress( function() {
		$grid.masonry('layout');
	});
	modalFunc();
}

if( document.getElementById('product_archive') ){
	var $grid = $('.product_list').masonry({
		itemSelector: '.col',
		columnWidth: '.colbase',
		percentPosition: true
	});
	$grid.imagesLoaded().progress( function() {
		$grid.masonry('layout');
	});
}

if( document.getElementById('product_archive') ){
	var $grid = $('.product_list').masonry({
		itemSelector: '.col',
		columnWidth: '.colbase',
		percentPosition: true
	});
	$grid.imagesLoaded().progress( function() {
		$grid.masonry('layout');
	});
}

});
